import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'
import { StatusBadge } from './StatusBadge'
import type { Level } from '@/lib/api/frameworkConfig'
import type { VersionedLevelLabels } from './types'

interface ActiveLevelDisplayProps {
  versionNumber: number
  levels: Level[]
  labels: VersionedLevelLabels
}

export function ActiveLevelDisplay({ versionNumber, levels, labels }: ActiveLevelDisplayProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>{labels.activeLevels}</CardTitle>
            <CardDescription>{labels.versionLabel(versionNumber)}</CardDescription>
          </div>
          <StatusBadge
            status="active"
            labels={{
              active: labels.statusActive,
              draft: labels.statusDraft,
              retired: labels.statusRetired,
            }}
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {levels.map((level) => (
            <div key={level.id} className="flex items-baseline gap-4 border-b py-2 last:border-b-0">
              <span className="w-8 text-sm font-medium text-muted-foreground">
                {level.level_number}
              </span>
              <span className="font-medium">{level.label}</span>
              {level.description && (
                <span className="text-sm text-muted-foreground">{level.description}</span>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
